// Copied verbatim from tab-portal src/lib/name-identification (qa c50f5268), the portal mirror of
// core-api src/utils/nameIdentification. Rules only: no AI pass. Keep the three in step.
import { BUSINESS_NAME_MAX_LEN, ParsedBusinessName } from './types'
import { extractTrailingParenthetical, normalizeName } from './normalize'

const splitAtWordBoundary = (
  text: string,
  maxLen: number,
): [string, string] => {
  if (text.length <= maxLen) return [text, '']

  let cut = maxLen
  while (cut > 0 && text[cut] !== ' ') cut -= 1
  if (cut <= 0) {
    return [text.slice(0, maxLen), text.slice(maxLen).trim()]
  }
  return [text.slice(0, cut).trim(), text.slice(cut).trim()]
}

/**
 * Split combined business name into IRS 40-char lines.
 * `raw2` is appended when present (legacy second column).
 */
export const parseBusinessName = (
  raw: string,
  raw2?: string | null,
): ParsedBusinessName => {
  const line1Input = normalizeName(raw)
  const line2Input = normalizeName(raw2)

  if (!line1Input && !line2Input) {
    return { businessName1: '', businessName2: '' }
  }

  if (!line1Input) {
    const [b1, b2] = splitAtWordBoundary(line2Input, BUSINESS_NAME_MAX_LEN)
    return { businessName1: b1, businessName2: b2 }
  }

  const { main, parenthetical } = extractTrailingParenthetical(line1Input)
  let combined = main
  if (line2Input) {
    combined = combined ? `${combined} ${line2Input}` : line2Input
  }

  const [businessName1, overflow] = splitAtWordBoundary(
    combined,
    BUSINESS_NAME_MAX_LEN,
  )

  const trailingParts = [overflow, parenthetical].filter(Boolean)
  const businessName2 = trailingParts
    .join(' ')
    .trim()
    .slice(0, BUSINESS_NAME_MAX_LEN)

  return { businessName1, businessName2 }
}
